<template>
  <ModuleSection title="新币种账户申请" class="transfer-result-page">
  <div class="transfer-result">
      <div class="transfer-result-back"></div>
      <img
        src="@/assets/image/transfer/transfer-success.png"
        alt=""
      >
    </div>
    <h3 style="text-align:center; color: #131523; font-size:16px; font-weight:bold;">{{ $t('开户申请提交成功') }}</h3>
    <div class="transfer-result-tip">
      {{ $t('您的新币种账户申请申请已提交至CBiBank，系统审核通过后将开通，请耐心等待。') }}
    </div>
    <div class="transfer-result-btns">
      <el-button
        class="transfer-back"
        @click="goBack()"
        type="info"
      >{{ $t('返回') }}</el-button>
    </div>
  </ModuleSection>
</template>

<script>
import ModuleSection from '@/components/container/ModuleSection'
export default {
  name: 'ElectronicAccountOpeningResult',
  created () {
    this.currency = this.$_params.getDisplay('creditCurrencyType', this.$route.query.currency)
  },
  data () {
    return {
      currency: ''
    }
  },
  components: {
    ModuleSection
  },
  methods: {
    goBack () {
      this.$router.push({
        name: 'ElectronicAccountOpeningSubmit'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.transfer-result-page {
  .transfer-result-message {
    margin: 60px auto 0;
    width: 500px;
    padding: 40px 10px 40px 0;
    border-radius: 10px;
    border: 1px dashed #d7dbec;

    ul {
      li {
        display: flex;
        align-items: center;
        padding-left: 132px;
        margin-bottom: 30px;

        label {
          width: 120px;
          margin-right: 10px;
          color: #333752;
          font-size: 14px;
        }

        span {
          color: #5a607f;
          font-size: 14px;
        }

        &:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }

  .transfer-result-btns {
    display: flex;
    justify-content: center;

    .transfer-next,
    .transfer-back {
      min-width: 140px;
    }
  }

  .transfer-result-tip {
    text-align: center;
    color: #131523;
    font-size: 14px;
    margin: 20px 0 40px;
  }

  .transfer-result {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    position: relative;

    .transfer-result-back {
      width: 100%;
      height: 123px;
      background: linear-gradient(
        180deg,
        rgba(251, 252, 254, 0) 0%,
        #f6f7fc 100%
      );
      border-radius: 10px;
      position: absolute;
      left: 0;
      top: -14px;
    }

    img {
      position: relative;
      z-index: 2;
      width: 220px;
      height: 150px;
      margin-bottom: 20px;
    }
  }
}
</style>
